import { useEffect, useState } from 'react'

import { commonService } from '../services'

const useCommunes = (cityId?: number) => {
  const [data, setData] = useState<any[] | null>(null)

  useEffect(() => {
    // console.log('useCommunes', cityId)
    if(cityId) getCommunes(cityId)
    else setData([])
  }, [cityId])

  const getCommunes = async (cityId: number) => {
    setData(null)
    const resp = await commonService.getCommunes(cityId)
    setData(resp.data)
  }

  const setEmpty = () => {
    setData([])
  }

  return {
    data,
    getCommunes,
    setEmpty
  }
}

export { useCommunes }